function myFunction() {
  console.log("dropdown");
  // document.getElementById("myDropdown").classList.toggle("show");
  var content;
  // content = document.getElementsByClassName("dropdown-content").classList.add("show");
  content = document.getElementById('myDropdown');
  console.log(content);
}

// ADDITIONAL CODE >>
// Listen on the 'click' event inside the myDropdown element"
// document.querySelector("#myDropdown").addEventListener("click", e =>{
//   // If the click was triggered by an <a> element:
//   if (e.target.nodeName !== "A"){
//     return;
//   }
//   // Set the value of the selected text to the input value:
//   document.querySelector("#filter-btn").value = e.target.textContent;
// })
// << ADDITIONAL CODE

function filterFunction() {
  var input, filter, ul, li, a, i;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  div = document.getElementById("myDropdown");
  a = div.getElementsByTagName("a");
  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
    } else {
      a[i].style.display = "none";
    }
  }
}


// Filter questions by input
function filterFunction() {
  console.log("filter");
  var input, filter, acc, elements, a, i, txtValue;
  input = document.getElementById("filter-btn");
  filter = input.value.toUpperCase();
  acc = document.getElementById("accordion");
  elements = acc.getElementsByClassName("card");

  for (i = 0; i < elements.length; i++) {
      a = elements[i].getElementsByTagName("a")[0];
      txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
          elements[i].style.display = "";
      } else {
          elements[i].style.display = "none";
      }
  }
}

// Filter questions by clicking in category icons
function filterAnswers(event) {

  var categoryValue, accordion;
  categoryValue = event.target.parentElement.getAttribute("data-category");
  accordion = document.getElementById("accordion");
  elements = accordion.getElementsByClassName("card");

    for (i = 0; i < elements.length; i++) {
      a = elements[i].getElementsByTagName("a")[0];
      attr = a.getAttribute("data-category");
      console.log(a, attr);
      if (attr === categoryValue) {
        elements[i].style.display = "block";
      } else {
        elements[i].style.display = "none";
      }
    }

}
